import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/components/base/base.component';
import { ClientMeasure } from 'src/app/domain/client-measure';
import { ClientMeasureService } from 'src/app/services/client-measure.service';
import { CoreData } from '../../core-data/core-data';
import { LoadingTask } from '../loading-task';

@Component({
    selector: 'app-standard-edition-box',
    templateUrl: './measure-edition-box.html',
    styleUrls: ['./measure-edition-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MeasureEditionBoxDialog extends BaseComponent implements OnInit {

    Model: ClientMeasure = new ClientMeasure();
    WithBattery: boolean;
    WithExpressDelay: boolean;
    HasFan: boolean;
    WithAccredited: boolean = false;

    constructor(
        protected coreData: CoreData,
        public LoadingTask: LoadingTask,
        private measureService: ClientMeasureService,
        public dialogRef: MatDialogRef<MeasureEditionBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data) {
        super(coreData)
        if (data.measure) {
            this.Model = data.measure;
        }
        if (data.withAccredited)
            this.WithAccredited = data.withAccredited
    }

    ngOnInit() {

    }

    CanSave() {
        return true;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {

        if (!this.CanSave())
            return;

        this.dialogRef.close();
    }

}
